var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{domProps:{"innerHTML":_vm._s(_vm.labelName)},on:{"click":function($event){if(!$event.altKey)return null;$event.preventDefault();$event.stopPropagation();return _vm.openModal.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }